

const ProfileInto= () => {
return (
<section className="py-3">
    <div className="container">
        <div className="row text-center mb-5">
            <div className="col-12">
                <h1 className='font-bold text-black text-uppercase pb-5'>People & Purpose</h1>
                <p>Fueled by our cutting-edge methodologies, Brand Acumen Studios has authored some of the branding world’s most legendary names. XBox. Escalade. Viagra.  </p>
                <p>Innovation is at the heart of what we do. We dream big and craft brand names that stand the test of time. For us, names are a signal to the world about what you stand for and what you’re here to change. They’re the heartbeat of your brand.  </p>
                <p> We remix art, language and science to develop profound brand identities—a powerful alchemy with a profound impact. Our imprint on the brand naming landscape is undeniable—and we’re just getting started.</p>
            </div>
        </div>
    </div>
</section>
);
};

export default ProfileInto;